module.exports = __webpack_public_path__ + "static/blason-ee31aa47b57c160069f5513381ccd063.svg";